var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "header",
      { staticClass: "header", attrs: { id: "layout-header" } },
      [
        _c("div", { staticClass: "d-flex" }, [
          _c("img", {
            staticClass: "company-logo",
            attrs: {
              src: "/static/images/vtclogo.png",
              alt: "logo",
              width: "200",
              height: "44"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "header-title" }, [
            _vm._v("Territory Mapping")
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "banner-img",
          attrs: {
            src: "/static/images/banner-img.png",
            alt: "logo",
            width: "auto",
            height: "120"
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50c21bee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c21bee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Front-Header.vue
// module id = null
// module chunks = 